import { Box, Grid } from "@mui/system";
import { Autocomplete, IconButton, TextField, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import ClicksWithFtdTable from "./ClickswithFtdTable";

const tableHeadings = {
  brand_name: "Brand Name",
  brand_id: "Brand ID",
  click_out: "Click Out",
  table: "Table",
  link_name: "Link Name",
};
export const rows = [
  {
    brand_name: "BetVictor Sport UK",
    brand_id: "2319",
    click_out: "137",
    table: "Bing - All Devices C",
    link_name:
      "5psFLottoGo_Casino_UK_new2_Generic_UK_100_Bonus_Up_To_200_newofferMarch12_12",
  },
  {
    brand_name: "BBetVictor Sport UK",
    brand_id: "2319",
    click_out: "137",
    table: "Bing - All Devices C",
    link_name:
      "AhukVideoslots_Casino_in_bingo_UK_Desktop_Mobile_Tablet_smart_tv_Unknown_UK_100_Up_To_50_16.04.26",
  },
];

const ClicksWithFtd = () => {
  const brandName = [
    { label: "Brand 01" },
    { label: "Brand 02" },
    { label: "Brand 03" },
    { label: "Brand 04" },
  ];

  return (
    <>
      <Grid container spacing={2} alignItems="center" px={2} py={1.5}>
        <Grid size={8}>
          <Typography variant="body1" fontSize={18}>
            5+ Clicks with 0 FTD in the Last 7 Days
          </Typography>
        </Grid>
        <Grid size={4}>
          <Box display={"flex"} alignItems={"end"} justifyContent={"flex-end"}>
            <Autocomplete
              id="assetOrSiteName"
              disablePortal
              options={brandName}
              getOptionLabel={(option) => option.label}
              size="small"
              sx={{ pt: "8px", width: "275px" }}
              renderInput={(params) => (
                <TextField
                  color="secondary"
                  {...params}
                  required
                  placeholder="Search Brand Name or choose from the list"
                  label="Brand Name"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <>
                        <SearchIcon
                          sx={{ fontSize: 20, mr: 1, color: "text.secondary" }}
                        />
                        {params.InputProps.startAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
            <IconButton
              aria-label="fingerprint"
              color="secondary"
              sx={{ ml: 2 }}
            >
              <DownloadIcon />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
      <ClicksWithFtdTable tableHeadings={tableHeadings} rows={rows} />
    </>
  );
};

export default ClicksWithFtd;
